import { useState } from 'react';

export const useModal = (initialState = false) => {
    const [showModal, setShowModal] = useState(initialState);

    const handleShow = () => {
        setShowModal(true);
    };

    const handleHide = () => {
        setShowModal(false);
    };

    return { showModal, handleShow, handleHide, setShowModal };
};
